<template>
    <div class="notFound">
        <h1>Page not found</h1>
        <router-link to="/">Go to Main Page</router-link>
    </div>
</template>

<script>
export default {
  name: 'notFound',
  components: {
  },
  data: () => ({
  }),
  created(){

  }
};
</script>
<style lang="scss">
    .notFound{
        text-align: center;
    }
</style>